import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ContentKlubIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ContentKlubIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M18.1649 22H5.82835C4.90275 22 4.14991 21.2472 4.14991 20.3216V9.13879C4.14991 8.21319 4.90275 7.46035 5.82835 7.46035H18.1649C19.0905 7.46035 19.8439 8.21319 19.8439 9.13879V20.3216C19.8439 21.2472 19.0905 22 18.1649 22ZM5.82835 8.46545C5.45684 8.46545 5.15501 8.76777 5.15501 9.13879V20.3216C5.15501 20.6926 5.45684 20.9949 5.82835 20.9949H18.1649C18.5364 20.9949 18.8388 20.6926 18.8388 20.3216V9.13879C18.8388 8.76777 18.5364 8.46545 18.1649 8.46545H5.82835Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M4.65245 16.9244C4.43897 16.9244 4.24903 16.7899 4.17837 16.5887C4.1077 16.3875 4.17149 16.1637 4.33787 16.0302L9.41344 11.9548C9.59454 11.8096 9.85072 11.8066 10.0348 11.948L12.178 13.598L13.9629 12.2522C14.1411 12.1168 14.3864 12.1188 14.5646 12.2503L19.6407 16.0184C19.8149 16.148 19.8865 16.3738 19.8183 16.5799C19.7506 16.785 19.5582 16.9244 19.3413 16.9244L4.65245 16.9244ZM10.768 15.9193H17.8214L14.2677 13.2809L10.768 15.9193ZM6.08109 15.9193H9.09836L11.3456 14.2252L9.7344 12.9855L6.08109 15.9193Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M7.2673 12.3484C6.29017 12.3484 5.4956 11.5544 5.4956 10.5777C5.4956 9.6011 6.29017 8.80604 7.2673 8.80604C8.24394 8.80604 9.0385 9.6011 9.0385 10.5777C9.0385 11.5544 8.24394 12.3484 7.2673 12.3484ZM7.2673 9.81115C6.84474 9.81115 6.50071 10.1547 6.50071 10.5777C6.50071 10.9998 6.84474 11.3434 7.2673 11.3434C7.68986 11.3434 8.0334 10.9998 8.0334 10.5777C8.0334 10.1547 7.68986 9.81115 7.2673 9.81115Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M8.53546 8.46545C8.29646 8.46545 8.08444 8.29466 8.04125 8.05025L7.31098 3.93561C7.27811 3.75206 7.34975 3.56557 7.49699 3.4517C7.64373 3.33686 7.84249 3.31428 8.01279 3.38987L10.0279 4.30074L11.594 2.2022C11.6892 2.0746 11.8384 2 11.9969 2C12.1554 2 12.3051 2.0746 12.3998 2.2022L13.9654 4.30074L15.9815 3.38987C16.1503 3.31428 16.3496 3.33687 16.4968 3.4517C16.644 3.56653 16.7157 3.75303 16.6828 3.93658L15.952 8.05123C15.9035 8.32312 15.6448 8.49881 15.3695 8.45759C15.0961 8.4095 14.9141 8.1484 14.9626 7.87455L15.5265 4.69826L14.0105 5.38338C13.7971 5.47957 13.5433 5.41479 13.401 5.22535L11.9969 3.34274L10.5923 5.22535C10.451 5.41479 10.1977 5.47957 9.98228 5.38338L8.46677 4.69826L9.03067 7.87552C9.07926 8.14839 8.89719 8.40949 8.62382 8.45758C8.59388 8.46249 8.56442 8.46545 8.53546 8.46545Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M6.97136 18.702C6.69358 18.702 6.46881 18.4772 6.46881 18.1995C6.46881 17.9217 6.69358 17.6969 6.97136 17.6969H17.0224C17.3002 17.6969 17.5249 17.9217 17.5249 18.1995C17.5249 18.4772 17.3002 18.702 17.0224 18.702"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.0071 20.2548H6.97136C6.69358 20.2548 6.46881 20.03 6.46881 19.7523C6.46881 19.4745 6.69358 19.2497 6.97136 19.2497H14.0071C14.2849 19.2497 14.5096 19.4745 14.5096 19.7523C14.5096 20.03 14.2849 20.2548 14.0071 20.2548Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M13.002 10.4923H10.9918C10.714 10.4923 10.4892 10.2676 10.4892 9.98979C10.4892 9.71201 10.714 9.48724 10.9918 9.48724H13.002C13.2798 9.48724 13.5045 9.71201 13.5045 9.98979C13.5045 10.2676 13.2798 10.4923 13.002 10.4923Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.0224 11.4974H15.0122C14.7344 11.4974 14.5096 11.2727 14.5096 10.9949C14.5096 10.7171 14.7344 10.4923 15.0122 10.4923H17.0224C17.3002 10.4923 17.5249 10.7171 17.5249 10.9949C17.5249 11.2727 17.3002 11.4974 17.0224 11.4974Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default ContentKlubIcon;
